/**
 * Created by jiachenpan on 16/11/18.
 */
import { Message } from "element-ui";

export function isvalidUsername(str) {
  const reg = /^[a-zA-Z0-9\-\.@_]+$/;
  return str && str.length > 0 && reg.test(str);
}
export function isValidCheckCode(str) {
  const reg = /^[0-9]+$/;
  return str && str.length === 4 && reg.test(str);
}
export function isValidModuleCode(str) {
  console.debug(str);
  const reg = /^[A-Za-z0-9_\-:]+$/;
  return str && reg.test(str);
}
/* 合法uri*/
export function validateURL(textval) {
  // eslint-disable-next-line max-len
  const urlregex = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
  return urlregex.test(textval);
}

/* 小写字母*/
export function validateLowerCase(str) {
  const reg = /^[a-z]+$/;
  return reg.test(str);
}

/* 大写字母*/
export function validateUpperCase(str) {
  const reg = /^[A-Z]+$/;
  return reg.test(str);
}

/* 大小写字母*/
export function validateAlphabets(str) {
  const reg = /^[A-Za-z]+$/;
  return reg.test(str);
}

/**
 * 卡号
 * @param {String} str
 */
export function validateAccount(str) {
  const reg = /^[0-9\-\ ]{8,23}$/;
  return reg.test(str);
}
/**
 * 卡号
 * @param {String} str
 */
export function validateCureNo(str) {
  const reg = /^[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/g;
  return reg.test(str);
}

/**
 * validate email
 * @param email
 * @returns {boolean}
 */
export function validateEmail(email) {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}

/* 千分节*/
export function format(num) {
  return (num + "").replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, "$&,");
}

export function notBlank(value, errorMsg) {
  if (!value || value.trim() === "") {
    showError(errorMsg);
    return false;
  }
  return true;
}
export function arrayNotEmpty(array, errorMsg) {
  if (!array || array.length === 0) {
    showError(errorMsg);
    return false;
  }
  return true;
}
export function isTrue(value, errorMsg) {
  if (!value) {
    showError(errorMsg);
    return false;
  }
  return true;
}
function showError(errorMsg) {
  Message({
    message: errorMsg,
    type: "error",
    duration: 5 * 1000
  });
}
export function validateLen(len) {
  return {
    max: len,
    message: '最大长度为' + len + '个字符',
    trigger: 'blur'
  };
}

export function GetDateTime() {
  var getDate = new Date();
  const dateYear = getDate.getFullYear(); // 获取年
  let dateMonth = getDate.getMonth() + 1; // 获取月
  let dateDate = getDate.getDate(); // 获取当日
  let dateHours = getDate.getHours(); // 获取小时
  let dateMinutes = getDate.getMinutes(); // 获取分钟
  let dateSeconds = getDate.getSeconds(); // 获取秒
  dateMonth = dateMonth < 10 ? "0" + dateMonth : dateMonth;
  dateDate = dateDate < 10 ? "0" + dateDate : dateDate;
  dateHours = dateHours < 10 ? "0" + dateHours : dateHours;
  dateMinutes = dateMinutes < 10 ? "0" + dateMinutes : dateMinutes;
  dateSeconds = dateSeconds < 10 ? "0" + dateSeconds : dateSeconds;
  return dateYear + dateMonth + dateDate + dateHours + dateMinutes + dateSeconds;
}
